import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { OperatorClient } from 'system/view-models/operator-list';
import { Operator } from 'shell/models/operator';
import { DateTime } from 'luxon';

export interface OperatorsResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  operators: Array<OperatorClient>;
}

export const transformerOperatorsList = (
  response: AxiosResponse<HttpResponseList<Operator>>
): OperatorsResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    operators: data.map((operator: Operator) => ({
      code: operator.key?.codiceOperatore || '',
      name: operator.cognomeNome || '',
      userExtended: operator.userEstesa || '',
      qualification: operator.qualifica?.descrizione || '',
      service: operator.servizio?.descrizioneBreve || '',
      serviceCode: operator.codiceServizio || '',
      fiscalCode: operator.codiceFiscale || '',
      codana: operator.codana || '',
      dateDeadline: operator.dataScadenza
        ? DateTime.fromISO(operator.dataScadenza)?.toFormat('dd/MM/yyyy')
        : '',
      hidden: {
        delete: true,
        edit: false,
        read: false,
      },
    })),
  };
};
